import { getImageUrlFromCdn } from './get-image-url-from-cdn';

const TEAM_LOGO_SIZE = 50;
const TEAM_LOGO_2X_SIZE = 100;

export const getTeamLogosUrls = (teamIcon?: string) => {
  return [
    getImageUrlFromCdn(teamIcon, TEAM_LOGO_SIZE),
    getImageUrlFromCdn(teamIcon, TEAM_LOGO_2X_SIZE),
  ];
};
